/**
 * Поля ввода телефона.
 *
 * intl-tel-input (118 КБ ядро + 262 КБ utils) загружается динамически.
 * Утилиты библиотека тянет своим `loadUtils` — отдельным чанком и только
 * когда поле реально инициализируется.
 *
 * ⚠️ CSS библиотеки остаётся статическим в main.js: он должен идти ДО
 * main.scss, чтобы наши правила перебивали вендорные порядком, а не
 * `!important`. Чанк же подключается после — порядок перевернулся бы.
 */

export default async function IntlTel() {
    const phoneInputs = document.querySelectorAll('input[type="tel"]');
    if (!phoneInputs.length) return;

    const {default: intlTelInput} = await import('intl-tel-input');

    phoneInputs.forEach(input => {
        intlTelInput(input, {
            initialCountry: 'ru',
            countryNameLocale: 'ru',
            strictMode: false,
            numberDisplayFormat: 'INTERNATIONAL',
            formatAsYouType: false,
            showFlags: false,
            separateDialCode: true,
            placeholderNumberPolicy: 'OFF',
            countrySelectorMode: 'AUTO',
            countrySearch: false,
            loadUtils: () => import('intl-tel-input/utils'),
        });
    });
}
